import { LIST_JEFES } from "@/apollo/queries/epp";
import {
  GET_LIST_CONTACTOS_USUARIOS,
  GET_LIST_CONTACTOS_USUARIOS_OPTS,
  GET_PAGINACION_CONTACTOS_LISTA,
} from "@/apollo/queries/mail";
import {
  CREATE_OR_UPDATE_JEFE_USUARIO,
  DELETE_JEFE_USUARIO,
} from "@/apollo/mutations/epp";
import { exMut, exQue } from "@/utils/gql";

export const JefesState = {
  jefes: [],
  jefesLoading: false,
  jefesUsuarios: [],
  jefesUsuariosFlat: [],
  jefesUsuariosPagination: [],
  jefesUsuariosPaginationFlat: [],
  jefesUsuariosFilters: {
    limite: 15,
    nombre: "",
    idGerencia: null,
  },
};

export const JefesMutations = {
  setJefes(state, jefes) {
    state.jefes = jefes;
  },
  setJefesLoading(state, isLoading) {
    state.jefesLoading = isLoading;
  },
  setJefesUsuarios(state, usuarios) {
    state.jefesUsuarios = Array.isArray(usuarios) ? usuarios : [];
  },
  setJefesUsuariosFlat(state, usuarios) {
    state.jefesUsuariosFlat = Array.isArray(usuarios) ? usuarios : [];
  },
  setJefesUsuariosPagination(state, pagination) {
    state.jefesUsuariosPagination = Array.isArray(pagination) ? pagination : [];
    state.jefesUsuariosPaginationFlat = state.jefesUsuariosPagination.reduce(
      (acc, page) => {
        if (Array.isArray(page?.ids)) {
          return acc.concat(page.ids);
        }
        return acc;
      },
      [],
    );
  },
  setJefesUsuariosFilters(state, filters) {
    state.jefesUsuariosFilters = {
      ...state.jefesUsuariosFilters,
      ...filters,
    };
  },
};

export const JefesActions = {
  async searchJefesUsuarios({ commit, dispatch, state }, payload = {}) {
    commit("setJefesLoading", true);
    try {
      const filters = {
        limite: Number(
          payload?.limite || state.jefesUsuariosFilters.limite || 15,
        ),
        nombre:
          payload?.nombre !== undefined
            ? String(payload.nombre || "").trim()
            : state.jefesUsuariosFilters.nombre,
        idGerencia:
          payload?.idGerencia !== undefined
            ? payload.idGerencia === null || payload.idGerencia === ""
              ? null
              : Number(payload.idGerencia)
            : state.jefesUsuariosFilters.idGerencia,
      };

      commit("setJefesUsuariosFilters", filters);
      commit("setJefesUsuariosPagination", []);
      commit("setJefesUsuarios", []);

      const pagination = await exQue(
        GET_PAGINACION_CONTACTOS_LISTA,
        {
          limite: filters.limite,
          idGerencia: filters.idGerencia,
          nombre: filters.nombre,
        },
        true,
      );

      const safePagination = Array.isArray(pagination) ? pagination : [];
      commit("setJefesUsuariosPagination", safePagination);

      if (safePagination.length) {
        dispatch("getJefesUsuariosPage", safePagination[0]);
        dispatch("getJefesUsuariosPageFlat");
      }

      return safePagination;
    } finally {
      commit("setJefesLoading", false);
    }
  },

  async getJefesUsuariosPage({ commit }, pageData) {
    commit("setJefesLoading", true);
    try {
      const ids = Array.isArray(pageData?.ids) ? pageData.ids : [];
      if (!ids.length) {
        commit("setJefesUsuarios", []);
        return [];
      }

      const page = await exQue(
        GET_LIST_CONTACTOS_USUARIOS,
        { idUsuario: ids },
        true,
      );

      const safePage = Array.isArray(page) ? page : [];
      commit("setJefesUsuarios", safePage);
      return safePage;
    } finally {
      commit("setJefesLoading", false);
    }
  },
  async getJefesUsuariosPageFlat({ commit, state }) {
    commit("setJefesLoading", true);
		
    exQue(
      GET_LIST_CONTACTOS_USUARIOS_OPTS,
      { idUsuario: state.jefesUsuariosPaginationFlat },
      true,
    )
      .then((page) => {
        const safePage = Array.isArray(page) ? page : [];
        commit("setJefesUsuariosFlat", safePage);
        return safePage;
      })
      .finally(() => {
        commit("setJefesLoading", false);
      });
  },

  async getJefes({ commit }) {
    commit("setJefesLoading", true);
    try {
      const response = await exQue(LIST_JEFES, {}, true);
      commit("setJefes", Array.isArray(response) ? response : []);
      return response;
    } finally {
      commit("setJefesLoading", false);
    }
  },

  async createOrUpdateJefeUsuario({ dispatch, commit }, payload) {
    commit("setJefesLoading", true);
    try {
      const response = await exMut(
        CREATE_OR_UPDATE_JEFE_USUARIO,
        {
          idUsuario: Number(payload?.id_usuario),
          usuarios: Array.isArray(payload?.usuarios)
            ? payload.usuarios.map((id) => Number(id))
            : [],
        },
        "Jefatura actualizada correctamente",
        "No se pudo actualizar la jefatura",
      );

      if (response) {
        await dispatch("getJefes");
      }

      return response;
    } finally {
      commit("setJefesLoading", false);
    }
  },

  async deleteJefeUsuario({ dispatch, commit }, id_usuario) {
    commit("setJefesLoading", true);
    try {
      const response = await exMut(
        DELETE_JEFE_USUARIO,
        { id_usuario: Number(id_usuario) },
        "Jefatura eliminada correctamente",
        "No se pudo eliminar la jefatura",
      );

      if (response) {
        await dispatch("getJefes");
      }

      return response;
    } finally {
      commit("setJefesLoading", false);
    }
  },
};
